export const parseSearch = () => {
  const parse = {};
  let search = decodeURIComponent(window.location.search);
  search = search.replace("?", "");
  search.split("&").map((obj) => {
    obj = obj.split("=");
    parse[obj[0]] = obj[1];
    return search;
  });
  delete parse[""];
  return parse;
};

export let config = {
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 0,
};
